import InputTags from './InputTags';

export default InputTags;
